/**
 * @generated SignedSource<<69fe8fb3c68aac51b127a79f9deb0faa>>
 * @relayHash fb6abb540a94d80996699945ba34e3c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19bb3736613b2eba6217cd31041e96804ac925bcddac6db684579988efe3b3fc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RecommendPremiumToStandardModalRendererQuery } from './RecommendPremiumToStandardModalRendererQuery.graphql';

const node: PreloadableConcreteRequest<RecommendPremiumToStandardModalRendererQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "19bb3736613b2eba6217cd31041e96804ac925bcddac6db684579988efe3b3fc",
    "metadata": {},
    "name": "RecommendPremiumToStandardModalRendererQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
